// extracted by css-extract-rspack-plugin
export default {"chewyCell":"chewyCell-wSItKz","chewyIcon":"chewyIcon-QNOqYl"};